import type { GeneratedImage } from '../services/api/imageGenerationService';

/** Keep machine instructions in the generation data, not in the gallery title. */
export const generatedImageTitle = (image: Pick<GeneratedImage, 'id' | 'product_name' | 'input_mode'>): string => {
  const action = image.input_mode === 'edit' ? '編集した画像' : image.input_mode === 'magic_resize' ? 'サイズ変更した画像' : 'バナー';
  return image.product_name?.trim() ? `${image.product_name.trim()}の${action}` : `${action} #${image.id}`;
};
